<template>

	<section>

		<slot name="mastheadOverride">
			<div class="masthead" :style="{backgroundImage: 'url('+mastheadBackgroundImage+')'}">
				<div class="masthead__inner"><slot name="masthead" /></div>
			</div>
		</slot>

		<div class="lower">
			<div><slot name="body" /></div>
		</div>

		<div class="footer">
			<slot name="footer" />
		</div>

	</section>

</template>

<script>

	export default {
		name: "layoutA",
		props: {
			mastheadBackgroundImage: String
		}
	}

</script>

<style lang="scss" scoped>

	@import "media";

	.masthead {
		position:relative; background-position:center; background-size:cover; padding:10rem 2rem 3rem;
		@include media(large) {
			padding:17.5rem 0 14.5rem;
		}
		&:before {
			position:absolute; left:0; right:0; top:0; bottom:0; background:rgba(#000, .2); content:'';
		}
		&__inner {
			position:relative; z-index:1;
			@include media(small, large) {
				padding:0 5vw;
			}
		}
	}

	body.embed-mode {
		.masthead {
			background:none !important; padding:8rem 2rem 4rem;
			&:before {
				display:none;
			}
		}
	}

	.lower {

	}

</style>



// WEBPACK FOOTER //
// src/layouts/layoutA/index.vue